export interface ChatBase {
  id: string;
  name: string;
  createdAt: string;
}

export interface Chat extends ChatBase {
  messages: ChatMessage[];
}

export enum ChatMessageType {
  MESSAGE = 'MESSAGE',
  AI_ERROR = 'AI_ERROR ',
}

export enum ChatMessageSource {
  USER = 'USER',
  GEMINI = 'GEMINI',
  SYSTEM = 'SYSTEM',
}

export interface ChatMessage {
  id: string;
  chatId: string;
  type: ChatMessageType;
  source: ChatMessageSource;
  message: string | null;
  messageJson: ChatMessageJson | null;
  createdAt: string;
}

export interface ChatMessageJson {
  embeddings?: number[] | null;
  matchedDocuments?: { id: string; similarity: any }[] | null;
  expandedMessage?: string;
  expandedEmbeddings?: number[] | null;
}

export enum ChatMessageText {
  PROCESSING_MESSAGE = 'PROCESSING_MESSAGE',
  PROCESSING_FAILED = 'PROCESSING_FAILED',
}
